import * as Sentry from '@sentry/react';

import { 
  SENTRY_DSN, 
  SENTRY_ENVIRONMENT, 
  SENTRY_SEND_DEFAULT_PII, 
  SENTRY_TRACES_SAMPLE_RATE, 
  SENTRY_DEBUG 
} from '@common/config/environments';
import { APP_VERSION } from '../version';

export const sentryInit = () => {

  Sentry.init({
    dsn: SENTRY_DSN,
    environment: SENTRY_ENVIRONMENT,
    release: `borrower-dashboard@v${APP_VERSION || '0.1.0'}`,
    initialScope: {
      tags: {
        application: 'borrower-dashboard',
        version: APP_VERSION
      }
    },
    ignoreErrors: [
      'Resource load error: SCRIPT',
    ],
    denyUrls: [
      /googletagmanager\.com/,
      /google-analytics\.com/,
      /inspectlet\.js/,
    ],
    sendDefaultPii: SENTRY_SEND_DEFAULT_PII,
    integrations: [
    ],
    tracesSampleRate: SENTRY_TRACES_SAMPLE_RATE,
    debug: SENTRY_DEBUG,
    beforeSend(event, hint) {
      // Never filter test errors - always send them
      if (event.tags?.testError || 
          (hint.originalException instanceof Error && hint.originalException.message?.includes('🧪 TEST ERROR'))) {
        console.log('📤 Sending test error to Sentry:', event);
        // Add unique fingerprint to prevent deduplication
        if (event.fingerprint) {
          event.fingerprint = [`test-error-${Date.now()}-${Math.random()}`];
        } else {
          event.fingerprint = [`test-error-${Date.now()}-${Math.random()}`];
        }
        return event;
      }

      // Filter out resource load errors triggered by known bots/crawlers
      if (event.tags?.errorType === 'resourceLoadError') {
        const botPatterns = [
          /Google-Read-Aloud/i,
          /Googlebot/i,
          /bingbot/i,
          /AhrefsBot/i,
          /SemrushBot/i,
          /facebookexternalhit/i,
        ];
        if (botPatterns.some(p => p.test(navigator.userAgent))) {
          return null;
        }
      }

      // Filter out known non-critical errors
      if (event.exception) {
        const error = hint.originalException;
        
        // Skip network errors that are not critical
        if (error instanceof Error && error.message.includes('Network Error')) {
          return null;
        }
        
        // Skip specific browser compatibility issues
        if (error instanceof Error && error.message.includes('ResizeObserver')) {
          return null;
        }
      }
      
      return event;
    }
  });
  
  // Verify initialization after a short delay
  setTimeout(() => {
    const client = Sentry.getClient();
    if (client) {
      console.log('✅ Sentry initialized successfully, DSN configured:', !!client.getDsn());
    } else {
      console.error('❌ Sentry client is not available after initialization');
    }
  }, 100);
}